const buildEndpoint = (pinpadIp, port) => {
  const protocol = 'http://';
  const endpoint = `${pinpadIp}:${port}`;
  return `${protocol}${endpoint}/`;
};

export { buildEndpoint };
